module.exports = __webpack_public_path__ + "img/20147617001970.62473f19.png";